import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TTTargetInput from './TTTargetInput';
import { updateTargetInputFieldData } from 'redux/translationTable/TranslationTableActions';

const mapDispatchToProps = dispatch => ({
  ttActions: bindActionCreators({ updateTargetInputFieldData }, dispatch)
});

export default connect(null, mapDispatchToProps)(TTTargetInput);



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowManager/c/ttMainGrid/c/ttTargetInput/TTTargetInputConnector.js